












































































































import { Component, Vue } from 'vue-property-decorator';
@Component({
})
export default class Historial extends Vue {
  private rating = 4;
  private loading = false;
  private comentarios = '';
  private selection = 1;
  private cards: any = [];
  private dialog = false;
  private idPetco = this.$store.getters.user;
  private errores = false;
  private citasCliente:any = [];
  private visibleCitas = 'd-none';
  private visibleResult = 'd-none';
  private idCita = '';
  private enable = true;
  // Snackbar
  private snackbar = false;
  private text = '';
  private type = '';
  private timeout = 2000;

  private async goTiendas(){
    this.$store.dispatch('resetAll');
    this.$router.push(await this.$store.dispatch('isDefined', this.$store.getters.idCallCenter) ? '/callCenter/tiendas' : '/tiendas');
  }

  private calificar(card: any) {
    this.dialog = true;
    this.idCita = card.ID_CITA;
    this.rating = card.CALIFICACION !== '' ? parseInt(card.CALIFICACION) : 4;
    this.comentarios = card.COMENTSOCIO !== '' ? card.COMENTSOCIO : undefined;
  }
  private sendCalificacion() {
    this.enable = false;
    let data = {
      idCita: this.idCita,
      calificacion: String(this.rating),
      comentSocio: this.comentarios
    };
    this.$store.dispatch('seguimiento', data)
    .then((result: any) => {
      this.dialog = false;
      this.enable = true;
      this.snackbar = true;
      this.text = 'Cita calificada. Gracias por sus comentarios.';
      this.type = 'success';
      this.timeout = 3000;
      const promise = this.$store.dispatch('getCitasClientePas', this.idPetco);
      promise.then((value) => {
        this.cards = value;
        this.errores = false;
        this.citasCliente = value;
        if (Object.keys(value).length === 0) {
          this.visibleCitas='';
          this.visibleResult='d-none';
        } else {
          this.visibleResult='';
          this.visibleCitas='d-none'

        }
      })
      .catch((error) => {
        this.errores = true;
      });
    })
    .catch((error: any) => {
      this.enable = true;
      this.snackbar = true;
      this.text = 'Error al calificar la cita, intente de nuevo más tarde.';
      this.type = 'error';
      this.timeout = 3000;
      const promise = this.$store.dispatch('getCitasClientePas', this.idPetco);
      promise.then((value) => {
        this.cards = value;
        this.errores = false;
        this.citasCliente = value;
        if (Object.keys(value).length === 0) {
          this.visibleCitas='';
          this.visibleResult='d-none';
        } else {
          this.visibleResult='';
          this.visibleCitas='d-none'

        }
      })
      .catch((error) => {
        this.errores = true;
      });
    });
  }
  private created() {
    const promise = this.$store.dispatch('getCitasClientePas', this.idPetco);
    promise.then((value) => {
      this.cards = value;
      this.errores = false;
      this.citasCliente = value;
      if (Object.keys(value).length === 0) {
        this.visibleCitas='';
        this.visibleResult='d-none';
      } else {
        this.visibleResult='';
        this.visibleCitas='d-none'

      }
    })
    .catch((error) => {
      this.errores = true;
    });
  }

  private cita() {
    this.$router.push('/tiendas');
  }

  private formatHours(item: any) {
    let stringDT = '';
    stringDT += item.substring(0, 2) + ':' + item.substring(2, 4);
    return stringDT;
  }
  // Recibe una fecha en formato yyyymmdd y la convierte a dd/mm/yyyy
  private formatDate(fecha: any) {
    const anio = fecha.substring(0, 4);
    const mes = fecha.substring(4, 6);
    const dia = fecha.substring(6, 8);
    let mesString = '';
    if (mes === '01') {
      mesString = 'Enero';
    } else if (mes === '02') {
      mesString = 'Febrero';
    } else if (mes === '03') {
      mesString = 'Marzo';
    } else if (mes === '04') {
      mesString = 'Abril';
    } else if (mes === '05') {
      mesString = 'Mayo';
    } else if (mes === '06') {
      mesString = 'Junio';
    } else if (mes === '07') {
      mesString = 'Julio';
    } else if (mes === '08') {
      mesString = 'Agosto';
   } else if (mes === '09') {
      mesString = 'Septiembre';
    } else if (mes === '10') {
      mesString = 'Octubre';
    } else if (mes === '11') {
      mesString = 'Noviembre';
    } else if (mes === '12') {
      mesString = 'Diciembre';
    }
    return dia  + ' / ' + mesString  + ' / ' + anio;
  }
}
